import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/site";
import { Reveal } from "./Reveal";

export const CTABanner = ({
  heading = "Ready to Get Started?",
  text = "Tell us what you need cleaned and we'll help you find the right cleaning service for your property.",
  ctaLabel = "Get a Free Quote",
  service = "",
}) => (
  <section className="section-pad !pb-24 sm:!pb-32" data-testid="cta-banner">
    <div className="container-site">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-navy-800 px-8 py-16 sm:px-16 sm:py-20">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-emerald-500/15" />
          <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-sky-500/15" />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{heading}</h2>
            <p className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">{text}</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <Link
                to={service ? `/contact?service=${encodeURIComponent(service)}` : "/contact"}
                data-testid="cta-banner-quote-button"
                className="btn-primary group"
              >
                {ctaLabel}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a href={BUSINESS.phoneHref} data-testid="cta-banner-call-button" className="btn-white">
                <Phone className="h-4 w-4" /> Call {BUSINESS.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
